<template>
    <div v-if="!visited" class="new-branding-animation-container">
        <div class="old-logo-container">
            <img src="/images/header-new-branding/old-logo-white.png" alt="old-logo" class="old-logo">
        </div>
        <div class="logo-text">
              <span class="logo-letter" v-for="(letter, index) in letters" :key="index">
                {{ letter }}
              </span>
        </div>
        <div class="logo">
            <div class="vertical-bars">
                <div class="bar bar-1"></div>
                <div class="bar bar-2"></div>
            </div>
            <div class="bbe-logo-container">
                <div class="logo-bbe-text">
                    <img class="logo-part-letter" src="/images/header-new-branding/logo_part_B.png" alt="">
                    <img class="logo-part-letter" src="/images/header-new-branding/logo_part_B.png" alt="">
                    <img class="logo-part-letter" src="/images/header-new-branding/logo_part_E.png" alt="">

                </div>
                <div class="logo-bbe-box">
                    <img class="logo-part logo-part1" src="/images/header-new-branding/logo_part0.png" alt="">
                    <img class="logo-part logo-part2" src="/images/header-new-branding/logo_part1.png" alt="">
                    <img class="logo-part logo-part3" src="/images/header-new-branding/logo_part2.png" alt="">
                </div>
            </div>
        </div>
        <p class="description">We are happy to launch our new identity & website</p>

    </div>
</template>

<script>
import {gsap} from "gsap";

export default {
    name: "HeaderAnimationNewBranding",
    data() {
        return {
            visited : localStorage.getItem('visited'),
            letters: ['I', 'S', ' ', 'N', 'O', 'W']

        }
    },
    mounted() {
        // this.startAnim()
        this.isFirstVisit()
        console.log(this.visited)
    },
    methods: {

        isFirstVisit() {
            if (!this.visited) {
                this.startAnim()
            }

        },
        startAnim() {
            let spreadMultiplier = window.innerWidth < 768 ? 35 : 60;
            let tlOptions = {
                height: '33px',
                top: '50%',
                duration: 1,
                ease: 'power2.out'
            }
            const tl = gsap.timeline();
            tl.set('.bar', {height: 0, top: '100%'})

            tl.to('.old-logo-container', {
                opacity: 0,
                duration: 1.4,
                display: 'none',
                ease: 'power2.out'
            },2)
                .to('.logo-letter', {
                    opacity: 1,
                    duration: 1.5,
                    ease: 'power2.in'
                },2.2)
                .to('.new-branding-animation-container', {
                    backgroundColor: '#0A0410',
                    duration: 3,
                    ease: 'power2.out'
                }, 3.3)
                .to('.logo-letter', {
                    y: 0,
                    x: (index) => (index - 1) * spreadMultiplier,
                    stagger: {
                        amount: 0,
                        from: 'center'
                    },
                    duration: 3.5,
                    ease: 'power2.out'
                }, 2.8)
                .to('.logo-letter', {
                    opacity: 0,
                    duration: 1.5,
                    ease: 'power2.out'
                }, 4.4)
                .to('.bar-1', tlOptions, 6)
                .to('.bar-2', {
                    ...tlOptions,
                }, 6.2)
                .to('.logo-part-letter', {
                    y: 0,
                    x: 0,
                    stagger: {
                        amount: 0.3,
                        from : 'end'
                    },
                    duration: 1.2
                }, 7)
                .to('.logo-bbe-box', {
                    x: 20,
                    stagger: {
                        amount: 0,
                        from : 'center'
                    },
                    duration: 1
                }, 7.7)

                .to('.logo-part1', {
                    left: 0,
                }, 8.6)
                .to('.logo-part2', {
                    left: 0,
                }, 8.9)

                .to('.description', {
                    letterSpacing: 3,
                    opacity: 1,
                    duration: 1,
                    autoRound: false,
                    ease: 'power2.in',
                    onComplete: () => {
                        localStorage.setItem('visited', true);
                    }
                })
        },

    }

}
</script>

<style scoped>

</style>
